import baseService from './baseService';
import colorApi from './color.js';

class NoticeService extends baseService{
  // 获取标的-列表
  static getChuzhiNoticeList(params) {
    return colorApi('paimai_disposalAnnouncementData', params, 'pmmall')
  }
}

export default NoticeService;

